import { useBranding } from '@repo/config-services';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Applies tenant-level branding to the document head: default page title and
 * favicon. Page-level <MetaTags> still override the title per route.
 *
 * The favicon is set imperatively rather than via <Helmet> so it replaces the
 * static index.html icon instead of adding a duplicate <link rel="icon"> (which
 * browsers may ignore in favour of the cached default). When the tenant
 * provides no favicon, the static index.html favicon is left untouched.
 */
export default function BrandingHead() {
  const { faviconUrl, productName } = useBranding();

  useEffect(() => {
    if (!faviconUrl) { return; }

    document.head
      .querySelectorAll("link[rel~='icon']")
      .forEach((icon) => icon.remove());

    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, [faviconUrl]);

  return (
    <Helmet>
      <title>{productName}</title>
    </Helmet>
  );
}
